import React from 'react';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import firebase from '../firebase';
import ModalButton from './ModalButton';
import ModelFormModal from './modals/ModelFormModal';
import useFirebaseUser from './hooks/useFirebaseUser';
import { auditData } from '../shared/models/user';

const db = firebase.firestore();

/**
 * 一括メモ追加ボタン
 *
 * @param {Object} props
 * @param {Array<{id: string, ref: firebase.firestore.DocumentReference}>} props.targets - 対象リスト
 * @param {Function} props.onSuccess - 成功時のコールバック
 * @param {string} [props.className] - 追加のCSSクラス
 */
export default function BulkAdminNoteButton({ targets, onSuccess, className }) {
  const { firebaseUser } = useFirebaseUser();

  const onSubmit = async ({ adminNote }, { onClickClose }) => {
    if (!window.confirm(`${targets.length}件にメモを追加しますか？`)) {
      return;
    }

    try {
      const batch = db.batch();
      targets.forEach(_ => {
        batch.update(_.ref, {
          adminNote,
          adminNoteUpdatedAt: new Date(),
          adminNoteUpdatedBy: auditData(firebaseUser),
        });
      });
      await batch.commit();

      toast.success(`${targets.length}件にメモを追加しました`);
      onClickClose();
      onSuccess?.();
    } catch (error) {
      console.error(error);
      toast.error('メモの追加に失敗しました');
    }
  };

  if (targets.length === 0) {
    return null;
  }

  return (
    <ModalButton
      className={className}
      Modal={ModelFormModal}
      modalProps={{
        title: '一括メモ追加',
        submitLabel: '追加',
        fields: {
          adminNote: {
            label: 'メモ',
            type: 'text',
            validations: {
              required: _ => !isEmpty(_),
            },
          },
        },
        onSubmit,
      }}
    >
      {targets.length}件にメモ追加
    </ModalButton>
  );
}
